/**
 * VK — PDP Recommendations Qty Controller (Shop-like)
 * Scope: product pages only, inside <product-recommendations>.
 *
 * v3 FIX: No longer blocks serves/variant button clicks.
 * The serves buttons are injected by product-recommendations.js _injectVariantButtons()
 * with their own click handlers. This script must NOT intercept those clicks.
 *
 * Behaviour:
 * - Add => /cart/add.js qty=1, then show stepper.
 * - Plus => immediately writes to cart (no extra Add click).
 * - Minus => immediately writes to cart; if reaches 0, shows Add.
 */

(function () {
  var SCOPE_BODY_OK =
    document.body.classList.contains("template-product") ||
    document.body.classList.contains("vk-template-product") ||
    document.body.classList.contains("vk-page-product");

  if (!SCOPE_BODY_OK) return;

  var ROOT_SELECTOR = "product-recommendations";

  // Reco-specific selectors
  var RECO_ADD_SELECTOR = "[data-vk-reco-add]";
  var RECO_MINUS_SELECTOR = "[data-vk-reco-minus]";
  var RECO_PLUS_SELECTOR = "[data-vk-reco-plus]";
  var RECO_CONTROL_SELECTOR = "[data-vk-reco-control]";
  var RECO_DISPLAY_SELECTOR = "[data-vk-reco-display]";
  var VARIANT_INPUT_SELECTOR = "[data-variant-id], input[name='id']";

  // Old-style qty selectors (fallback)
  var QTY_ROOT_SELECTOR = ".vk-qty";
  var OLD_ADD_SELECTOR = ".vk-qtyAdd, [data-vk-qty-add]";
  var OLD_MINUS_SELECTOR = ".vk-qtyBtn[data-vk-qty-minus], [data-vk-qty-minus], [data-qty-minus]";
  var OLD_PLUS_SELECTOR = ".vk-qtyBtn[data-vk-qty-plus], [data-vk-qty-plus], [data-qty-plus]";

  // Serves button selector — we must NOT intercept these
  var SERVES_BTN_SELECTOR = "[data-serves-id]";

  function toInt(v, d) {
    var n = parseInt(String(v || ""), 10);
    return isFinite(n) ? n : (d || 0);
  }

  function isInsideRecommendations(node) {
    return !!(node && node.closest && node.closest(ROOT_SELECTOR));
  }

  function getFormFromNode(node) {
    return node.closest("form[data-reco-add-form]") || node.closest("form[action='/cart/add']");
  }

  function emitCartUpdated(detail) {
    try {
      window.dispatchEvent(new CustomEvent("vk:cart:updated", { detail: detail || {} }));
    } catch (e) {}
  }

  function fetchCart() {
    return fetch("/cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    }).then(function (r) {
      if (!r.ok) throw new Error("cart.js failed");
      return r.json();
    });
  }

  function findLineForVariant(cart, variantId) {
    var idNum = Number(variantId);
    if (!cart || !cart.items || !cart.items.length) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (Number(cart.items[i].variant_id) === idNum) return cart.items[i];
    }
    return null;
  }

  function addVariant(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ id: Number(variantId), quantity: qty }),
      credentials: "same-origin"
    }).then(function (r) {
      if (!r.ok) throw new Error("add.js failed");
      return r.json();
    });
  }

  function changeByKey(lineKey, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ id: String(lineKey), quantity: qty }),
      credentials: "same-origin"
    }).then(function (r) {
      if (!r.ok) throw new Error("change.js failed");
      return r.json();
    });
  }

  // ---- ADD / PLUS / MINUS HANDLING ----

  function handleRecoAdd(form) {
    if (form.dataset.busy === "true") return;
    form.dataset.busy = "true";

    var variantInput = form.querySelector(VARIANT_INPUT_SELECTOR);
    var variantId = toInt(variantInput ? variantInput.value : 0, 0);
    if (!variantId) { form.dataset.busy = "false"; return; }

    var control = form.querySelector(RECO_CONTROL_SELECTOR);
    var display = form.querySelector(RECO_DISPLAY_SELECTOR);

    addVariant(variantId, 1).then(function () {
      return fetchCart();
    }).then(function (cart) {
      var line = findLineForVariant(cart, variantId);
      var qty = line ? toInt(line.quantity, 1) : 1;
      if (control) control.classList.add("is-active");
      if (display) display.textContent = String(qty);
      emitCartUpdated({ action: "add", variantId: variantId });
    }).catch(function (e) {
      console.error("[VK reco] add error:", e);
    }).finally(function () {
      form.dataset.busy = "false";
    });
  }

  function handleRecoPlus(form) {
    if (form.dataset.busy === "true") return;
    form.dataset.busy = "true";

    var variantInput = form.querySelector(VARIANT_INPUT_SELECTOR);
    var variantId = toInt(variantInput ? variantInput.value : 0, 0);
    if (!variantId) { form.dataset.busy = "false"; return; }

    var display = form.querySelector(RECO_DISPLAY_SELECTOR);

    addVariant(variantId, 1).then(function () {
      return fetchCart();
    }).then(function (cart) {
      var line = findLineForVariant(cart, variantId);
      var qty = line ? toInt(line.quantity, 1) : 1;
      if (display) display.textContent = String(qty);
      emitCartUpdated({ action: "plus", variantId: variantId });
    }).catch(function (e) {
      console.error("[VK reco] plus error:", e);
    }).finally(function () {
      form.dataset.busy = "false";
    });
  }

  function handleRecoMinus(form) {
    if (form.dataset.busy === "true") return;
    form.dataset.busy = "true";

    var variantInput = form.querySelector(VARIANT_INPUT_SELECTOR);
    var variantId = toInt(variantInput ? variantInput.value : 0, 0);
    if (!variantId) { form.dataset.busy = "false"; return; }

    var control = form.querySelector(RECO_CONTROL_SELECTOR);
    var display = form.querySelector(RECO_DISPLAY_SELECTOR);

    fetchCart().then(function (cart) {
      var line = findLineForVariant(cart, variantId);
      if (!line || !line.key) {
        if (control) control.classList.remove("is-active");
        if (display) display.textContent = "1";
        return null;
      }
      var nextQty = Math.max(0, toInt(line.quantity, 0) - 1);
      return changeByKey(line.key, nextQty).then(function () {
        if (nextQty <= 0) {
          if (control) control.classList.remove("is-active");
          if (display) display.textContent = "1";
        } else {
          if (display) display.textContent = String(nextQty);
        }
        emitCartUpdated({ action: "minus", variantId: variantId });
      });
    }).catch(function (e) {
      console.error("[VK reco] minus error:", e);
    }).finally(function () {
      form.dataset.busy = "false";
    });
  }

  // ---- HYDRATE EXISTING CARDS ----

  function hydrateCards() {
    var forms = document.querySelectorAll(ROOT_SELECTOR + " form[data-reco-add-form], " + ROOT_SELECTOR + " form[action='/cart/add']");
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (form.dataset.vkHydrated === "1") continue;
      form.dataset.vkHydrated = "1";

      var variantInput = form.querySelector(VARIANT_INPUT_SELECTOR);
      var variantId = toInt(variantInput ? variantInput.value : 0, 0);
      if (!variantId) continue;

      (function (f, vid) {
        fetchCart().then(function (cart) {
          var line = findLineForVariant(cart, vid);
          var control = f.querySelector(RECO_CONTROL_SELECTOR);
          var display = f.querySelector(RECO_DISPLAY_SELECTOR);

          if (line && Number(line.quantity) > 0) {
            if (control) control.classList.add("is-active");
            if (display) display.textContent = String(line.quantity);
          } else {
            if (control) control.classList.remove("is-active");
            if (display) display.textContent = "1";
          }
        }).catch(function () {});
      })(form, variantId);
    }
  }

  // Initial hydration
  hydrateCards();

  // Watch for async recommendation loads
  new MutationObserver(function (mutations) {
    var shouldHydrate = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (!node || node.nodeType !== 1) continue;
        if ((node.matches && node.matches(ROOT_SELECTOR)) ||
            (node.querySelector && node.querySelector(ROOT_SELECTOR)) ||
            (node.querySelector && node.querySelector("form[data-reco-add-form]"))) {
          shouldHydrate = true;
          break;
        }
      }
      if (shouldHydrate) break;
    }
    if (shouldHydrate) {
      // Delay slightly to let _injectVariantButtons() finish first
      setTimeout(hydrateCards, 200);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  // ---- SINGLE EVENT DELEGATION (CAPTURE PHASE) ----
  // CRITICAL: We explicitly SKIP serves buttons so their own handlers work

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1) return;
    if (!isInsideRecommendations(t)) return;

    // SKIP serves/variant buttons — let their own handlers (from _injectVariantButtons) work
    if (t.closest(SERVES_BTN_SELECTOR)) {
      return; // DO NOT intercept
    }

    // RECO ADD BUTTON
    var addBtn = t.closest(RECO_ADD_SELECTOR);
    if (addBtn) {
      var form = getFormFromNode(addBtn);
      if (form) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
        handleRecoAdd(form);
        return;
      }
    }

    // RECO PLUS BUTTON
    var plusBtn = t.closest(RECO_PLUS_SELECTOR);
    if (plusBtn) {
      var form2 = getFormFromNode(plusBtn);
      if (form2) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
        handleRecoPlus(form2);
        return;
      }
    }

    // RECO MINUS BUTTON
    var minusBtn = t.closest(RECO_MINUS_SELECTOR);
    if (minusBtn) {
      var form3 = getFormFromNode(minusBtn);
      if (form3) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
        handleRecoMinus(form3);
        return;
      }
    }

    // FALLBACK: Old-style qty selectors
    var qtyRoot = t.closest(QTY_ROOT_SELECTOR);
    if (!qtyRoot) return;

    var isOldAdd = !!t.closest(OLD_ADD_SELECTOR);
    var isOldPlus = !!t.closest(OLD_PLUS_SELECTOR);
    var isOldMinus = !!t.closest(OLD_MINUS_SELECTOR);

    if (!(isOldAdd || isOldPlus || isOldMinus)) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    var oldForm = getFormFromNode(t);
    if (oldForm) {
      if (isOldAdd) handleRecoAdd(oldForm);
      else if (isOldPlus) handleRecoPlus(oldForm);
      else if (isOldMinus) handleRecoMinus(oldForm);
    }
  }, true); // CAPTURE phase

})();